'use client';

import { signOut } from 'next-auth/react';
import React from 'react';
import { toast } from 'sonner';
import { DropdownMenuItem } from '~/components/ui/dropdown-menu';

type SignOutButtonProps = {
  children: React.ReactNode;
  exitUrl?: string;
};

export const SignOutButton = (props: SignOutButtonProps) => {
  const handleSignOutClick = async () => {
    window.sessionStorage.removeItem('CalendarPopupSeen');
    window.sessionStorage.removeItem('CalendarPopupNotRequired');
    await toast
      .promise(
        signOut({
          redirect: false,
        }),
        {
          loading: 'Signing out...',
          success: 'Thanks for visiting, come back soon!',
          error: 'Failed to sign out',
        },
      )
      .unwrap();

    // Clear the SLI cookie
    await fetch('/api/sli', {
      method: 'DELETE',
    });

    if (props.exitUrl) {
      window.location.href = props.exitUrl;
    } else {
      window.location.reload();
    }
  };

  return (
    <DropdownMenuItem asChild className="w-full">
      <button onClick={handleSignOutClick}>{props.children}</button>
    </DropdownMenuItem>
  );
};

SignOutButton.displayName = 'SignOutButton';
